import { cloneElement, isValidElement, ReactNode, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useLang } from '../../context/LangContext';
// import type { CarStore } from '../../hooks/useCarStore';
// import type { IconId } from '../../types';
// import { ROUTES } from '../../router/routes';
// import { Icon } from '../../icons/Icons';
// import { avatarBg } from '../../utils/format';
import styles from './styles.module.css';
import { useLocale } from 'next-intl';
import { avatarBg } from '@/functions/formats';
import MainIcons from '@/icons/main';
import AppLink from '@/components/common/AppLink';
import { useLayoutContext } from '@/context/LayoutContext';
import UserInfo from '@/components/pages/profile/ProfileContent/AccountHero/UserInfo';
import UserAvatar from '@/components/pages/profile/ProfileContent/AccountHero/UserInfo/UserAvatar';
import { TRIGGERS } from '@/api/global';

interface MenuEntry {
  label: string;
  icon: ReactNode;
  href?: string | null;
  iconBg: string;
  iconColor: string;
  onClick?: () => void;
}

export function UserMenu() {
  const lang = useLocale();
  const { logoutFunction, activeCar, setTrigger, userInfo } = useLayoutContext();

  const ml =
    lang === 'fa'
      ? {
          wallet: 'کیف پول',
          history: 'تاریخچه پرداخت‌ها',
          users: 'لیست کاربران ثبت شده',
          account: 'حساب کاربری',
          myplates: 'پلاک‌های من',
          logout: 'خروج از حساب کاربری',
        }
      : {
          wallet: 'Wallet',
          history: 'Payment history',
          users: 'Registered users',
          account: 'Account',
          myplates: 'My plates',
          logout: 'Log out',
        };

  const menu: MenuEntry[] = [
    {
      label: ml?.wallet,
      icon: <MainIcons.walletIcon />,
      href: '/wallet',
      iconBg: avatarBg(7),
      iconColor: 'var(--danger)',
    },
    {
      label: ml?.history,
      icon: <MainIcons.clockIcon />,
      href: '/payment-history',
      iconBg: avatarBg(6),
      iconColor: 'var(--brand-deep)',
    },
    {
      label: ml?.users,
      icon: <MainIcons.usersIcon />,
      href: null,
      iconBg: avatarBg(9),
      iconColor: 'var(--green)',
      onClick: () => {
        setTrigger(TRIGGERS.SUBUSER_MODAL);
      },
    },
    {
      label: ml?.account,
      icon: <MainIcons.userIcon />,
      href: '/profile',
      iconBg: 'var(--purple-bg)',
      iconColor: 'var(--purple)',
    },
    {
      label: ml?.myplates,
      icon: <MainIcons.carIcon />,
      href: '/plates',
      iconBg: avatarBg(7),
      iconColor: 'var(--danger)',
    },
  ];

  const arrow = lang === 'fa' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6';
  const renderItem = (m: MenuEntry) => (
    <>
      <span className={styles.itemIcon} style={{ background: m?.iconBg, color: m?.iconColor }}>
        {isValidElement(m?.icon)
          ? cloneElement(m?.icon, {
              fill: m?.iconColor,
              width: `18px`,
              height: `18px`,
            })
          : m?.icon}
      </span>
      <span className={styles.itemLabel}>{m?.label}</span>
      <MainIcons.arrowIcon className={`${styles.arrowIcon}`} width="15px" height="15px" />
    </>
  );

  return (
    <>
      <div className={`${styles.head}`}>
        <UserAvatar name={userInfo?.name} colorNumber={0} avatarClass={styles.headAvatar} />
        <div className={`${styles.headText}`}>
          <span className={`${styles.headName}`}>{userInfo?.name}</span>
          <span className={`${styles.headPhone} ltr`}>{userInfo?.mobile}</span>
        </div>
      </div>
      <div className={styles.body}>
        {menu?.map((m) => (
          <>
            {m?.href ? (
              <AppLink key={m?.label} href={m?.href} className={styles.item}>
                {renderItem(m)}
              </AppLink>
            ) : (
              <div className={styles.item} onClick={m?.onClick}>
                {renderItem(m)}
              </div>
            )}
          </>
        ))}

        <div className={styles.divider} />

        <button className={styles.logout} onClick={logoutFunction}>
          <span className={styles.logoutIcon}>
            <MainIcons.logoutIcon width="18px" height="18px" />
          </span>
          <span className={styles.logoutLabel}>{ml?.logout}</span>
        </button>
      </div>
    </>
  );
}
